import { createApi } from "@reduxjs/toolkit/query/react";
import {
  baseQueryWithArgs,
  getQueryStringWithCreator,
} from "../utils/reduxHelper";

export const brandSourcingReduxAPI = createApi({
  reducerPath: "brandSourcingReduxAPI",
  baseQuery: baseQueryWithArgs,
  tagTypes: ["brandSourcingCollections"],

  endpoints: (builder) => ({
    //GET Queries
    getRecommendedBrandSourcingCollections: builder.query({
      query: ({ isFirstVisit = false }) =>
        getQueryStringWithCreator(
          `s/getRecommendedBrandSourcingCollections?isFirstVisit=${isFirstVisit}`
        ),
      providesTags: ["brandSourcingCollections"],
      keepUnusedDataFor: 60,
    }),
    getSubcategoriesFromCategory: builder.query({
      query: (categoryId) =>
        getQueryStringWithCreator(
          `s/getSubcategoriesFromCategory?categoryId=${categoryId}`
        ),
      providesTags: ["subcategories"],
      keepUnusedDataFor: 60,
    }),
    getBrandsEndlessForHome: builder.query({
      query: ({ page }) => {
        return getQueryStringWithCreator(
          `s/getBrandsEndlessForHome?page=${page}`
        );
      },
      providesTags: ["homeSearchProducts"],
    }),
    getAllBrandCartsList: builder.query({
      query: () => getQueryStringWithCreator(`s/getAllBrandCartsList`),
      providesTags: ["allBrandCartsList"],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useLazyGetCategoriesQuery,
  useGetRecommendedBrandSourcingCollectionsQuery,
  useGetAllBrandCartsListQuery,
} = brandSourcingReduxAPI;
